export { Homepage, type HomepageProps } from "~/components/Homepage/Homepage";
